import React, { useState, useEffect, useContext } from 'react';
import 'antd/dist/antd.css';
import { Checkbox, Collapse, Row, Col, Typography } from 'antd';
import icon_edit_pencil from 'images/icon_edit_pencil.svg';
import button_arrow_left from 'images/button_arrow_left.svg';
import { updateOrCreateAnalysis } from 'services/project';

import { AppContext } from 'context/AppContext';
import axios from 'services/axios_config';

import { getAnalysisData } from 'services/second_sider_analysis';

import Analysis from 'components/content/projectView/Analysis';
import { cloneDeep } from 'lodash';

const { Panel } = Collapse;

const SecondSiderAnalysis = (props) => {
    let appContext = useContext(AppContext);

    const handleAsideVisible = () => {
        appContext.setAsideIsVisible(!appContext.asideIsVisible);
    };

    return (
        <>
            <div
                className="max"
                id="univariate-container"
                style={{
                    width: '270px',
                    height: '100vh',
                    backgroundColor: '#407cb1',
                    transition: 'width 5s',
                    padding: '10px 0px 20px 20px',
                    color: 'white',
                    position: 'sticky',
                    top: 0,
                    zIndex: 10
                }}
            >
                <img
                    alt=""
                    className="button-arrow-left-nav"
                    onClick={() => {
                        handleAsideVisible();
                        props.analysis.setRerenderAnalysisView(
                            !props.analysis.rerenderAnalysisView
                        );
                    }}
                    src={button_arrow_left}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        right: '-16px',
                        zIndex: '100'
                    }}
                />

                <Analysis
                    setRerenderAnalysisView={props.setRerenderAnalysisView}
                    rerenderAnalysisView={props.rerenderAnalysisView}
                    tableColumn={props.tableColumn}
                    analysis={props.analysis}
                    rerenderProjectData={props.rerenderProjectData}
                    setRerenderProjectData={props.setRerenderProjectData}
                    setSpinnerFullProjectView={props.setSpinnerFullProjectView}
                    scrollToFunction={props.scrollToFunction}
                    setScrollToFunction={props.setScrollToFunction}
                />
            </div>
        </>
    );
};

export default SecondSiderAnalysis;
